module.exports = __webpack_public_path__ + "static/media/img-client-mobile.36f78569.jpg";